import React from "react";
import Label from "../../../../../common/components/Label";
import { ICampaignNameDetails } from "./CampaignSetupForm";
import StackWrapper from "../../StackWrapper";
import { TextField } from "@mui/material";

interface IProps extends ICampaignNameDetails {}

const CampaignName: React.FC<IProps> = ({
  campaignName,
  handleUpdateCampaignName,
  error
}) => {
  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const value = e.target.value;
    handleUpdateCampaignName(value);
  };

  const handleBlur = () => {
    // Replace multiple spaces with a single space
    const updatedValue = campaignName.replace(/\s+/g, " ").trim();
    handleUpdateCampaignName(updatedValue);
  };

  return (
    <StackWrapper>
      <Label
        colorType="light"
        label="Campaign name"
        required
        labelFor="campaignName"
      />

      <TextField
        variant="outlined"
        value={campaignName}
        onChange={handleChange}
        onBlur={handleBlur}
        fullWidth
        margin="normal"
        placeholder="Campaign name"
        sx={{ m: 0 }}
        error={!!error}
        helperText={!!error && !campaignName ? error : ""}
        autoComplete="off"
      />
    </StackWrapper>
  );
};

export default React.memo(CampaignName);
